import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom'
import useSWR from 'swr'
import { LoadingNormal } from '~/src/components/organisms/Loading/LoadingNormal'
import { HeaderMember, Members } from '~/src/components/organisms/Members'
import { ProtectedPage } from '~/src/components/templates'
import { useMessage } from '~/src/hooks'
import { userRepository } from '~/src/repositories'

interface IGetUserParams {
  offset?: number
  limit?: number
  countryId?: string
  email?: string
  name?: string
}

export const ListMember: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const { handleOpenWithErrorMessage } = useMessage()
  const navigate = useNavigate()
  const location = useLocation()
  const [members, setMembers] = useState<any>()

  const [params, setParams] = useState<IGetUserParams>(
    // @ts-ignore
    location.state && location.state.prevState
    ? // @ts-ignore
      (location.state.prevState as IGetUserParams)
    : location.state
    ? (location.state as IGetUserParams)
    : ({} as IGetUserParams)
  )
  const { data: listMember, error } = useSWR(['/users', params], () =>
    userRepository.getUser(params)
  )

  useEffect(() => {
    if (error) handleOpenWithErrorMessage(error)
  }, [error, handleOpenWithErrorMessage])

  useEffect(() => {
    if (listMember) {
      setMembers(listMember)
    }
  }, [listMember])

  const handleGetUsers = async (_params?: IGetUserParams) => {
    let mergedParams = _params
    if (location.state) {
      // @ts-ignore
      mergedParams = { ...location.state, ..._params }
    }
    // @ts-ignore
    setParams(mergedParams)
    navigate(
      {
        pathname: location.pathname,
        // @ts-ignore
        search: `?${createSearchParams(mergedParams)}`,
      },
      { state: mergedParams }
    )
  }

  if (!members) return <LoadingNormal />

  return (
    <ProtectedPage pageTitle={t('list_member.member')}>
      <HeaderMember onSubmit={handleGetUsers} params={params} />
      <Members
        onSubmitGetUser={handleGetUsers}
        users={members.users}
        pagination={members.pagination}
      />
    </ProtectedPage>
  )
}
